import React, { Fragment } from 'react';
import { withHandlers, withProps, lifecycle, compose, getContext, branch, renderNothing } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { unsetFirstLogin } from '../auth/actions';
import { getFirstLogin } from '../auth/selectors';
import NavExplainer from '../sidebar/navigation/NavExplainer';
import { flagNames, withInjectFeatureFlagsToProps } from '../../modules/infra/feature-flags';
import { sessionKVStore } from '../../modules/infra/persistence';
import { t } from '../../modules/infra/i18n';

const FirstLoginWelcomeContainer = compose(
  withInjectFeatureFlagsToProps([flagNames.SHOP_ONBOARDING]),
  withProps(() => ({
    hideForTests: sessionKVStore.getItem('squire_hideFirstLoginWelcome') === 'true',
  })),
  branch((props) => props[flagNames.SHOP_ONBOARDING] || props.hideForTests, renderNothing),
  connect(
    (state) => ({
      firstLogin: getFirstLogin(state),
    }),
    { unsetFirstLogin }
  ),
  withHandlers({
    close: (props) => () => props.unsetFirstLogin(),
  }),
  getContext({
    toggleSidebar: PropTypes.func.isRequired,
  }),
  withProps(() => ({
    title: t('auth:first_login.welcome_title'),
    description: (
      <>
        {t('auth:first_login.help_description_line1')}
        <br />
        {t('auth:first_login.help_description_line2')}
      </>
    ),
  })),
  lifecycle({
    componentDidMount() {
      if (this.props.firstLogin) {
        this.props.toggleSidebar(true);
      }
    },
  })
)(NavExplainer);

export default FirstLoginWelcomeContainer;
